// Inline SVG ornaments used on the OCEN home page.

// Arrow for buttons
export const Arrow = ({ size = 14 }: { size?: number }) => (
  <svg className="arrow" width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="1" y1="7" x2="13" y2="7" />
    <polyline points="8,2 13,7 8,12" />
  </svg>
);
